import { collection, query, where, getDocs, Timestamp } from 'firebase/firestore';
import { db } from '../../config';
import { WebhookEndpointType } from '../../../../types/webhook';
import { WebhookEventType } from '../../../../constants/enum';

interface RawDoc {
  endpoint_id: string;
  company_id: string;
  pattern_id: string;
  url: string;
  enabled: boolean;
  event_type: WebhookEventType;
  secret_last4: string;
  status: number;
  last_delivery_at?: Timestamp;
  last_delivery_status?: number;
  last_delivery_http_status?: number;
  created_at: Timestamp;
  created_by: string;
  updated_at: Timestamp;
  updated_by: string;
}

const toDate = (ts: Timestamp | undefined): Date | undefined => (ts ? ts.toDate() : undefined);

const fromRaw = (raw: RawDoc): WebhookEndpointType => ({
  endpoint_id: raw.endpoint_id,
  company_id: raw.company_id,
  pattern_id: raw.pattern_id,
  url: raw.url,
  enabled: raw.enabled,
  event_type: raw.event_type,
  secret_last4: raw.secret_last4,
  status: raw.status,
  last_delivery_at: toDate(raw.last_delivery_at),
  last_delivery_status: raw.last_delivery_status,
  last_delivery_http_status: raw.last_delivery_http_status,
  created_at: toDate(raw.created_at) ?? new Date(0),
  created_by: raw.created_by,
  updated_at: toDate(raw.updated_at) ?? new Date(0),
  updated_by: raw.updated_by,
});

/**
 * パターン ID に紐づく Webhook エンドポイントを全件取得する（1 パターン = 最大 2 件）。
 * セキュリティルールが list クエリで company_id の一致を証明できるよう、
 * company_id の等価フィルタを必ず含める。
 */
export const getWebhookEndpointsByPatternId = async (
  patternId: string,
  companyId: string,
): Promise<WebhookEndpointType[]> => {
  const q = query(
    collection(db, 'webhook_endpoints'),
    where('pattern_id', '==', patternId),
    where('company_id', '==', companyId),
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => fromRaw(d.data() as RawDoc));
};
